import {
    EncodeData,
    DecodeData
} from './EncodeDecodeData';

export {
    EncodeData,
    DecodeData
};

export default EncodeData;
